import React, {useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import { updatePassword } from "../../Actions/passwordUpdateAction";
import { passwordUpdateSelector } from "../../Reducers/passwordUpdateReducer";

const PasswordUpdateSection = () => {
    const [showSuccess, setShowSuccess] = useState(false);
    const [showFailed, setShowFailed] = useState(false);
    const [isFormValid, setIsFormValid] = useState(false);
    const [buttonText, setButtonText] = useState("Update Password");
    const formRef = useRef(null);
    const passwordUpdateState = useSelector(passwordUpdateSelector);
    const dispatch = useDispatch();

    useEffect(() => {
        if (passwordUpdateState.success === true) {
            setShowSuccess(true);
            // Clear form only on success
            formRef.current.reset();
            setIsFormValid(false);
            setButtonText("Update Password");
            setTimeout(() => {
                setShowSuccess(false);
            }, 5000)
        } else if (passwordUpdateState.success === false) {
            setShowFailed(true);
            setTimeout(() => {
                setShowFailed(false);
            }, 5000)
        }
    }, [passwordUpdateState]);

    const validateForm = (form) => {
        const newPassword = form.newPassword.value;
        const confirmPassword = form.confirmPassword.value;
        
        const isNewPasswordValid = newPassword && newPassword.length >= 8;
        const isPasswordsMatching = newPassword === confirmPassword;
        const isValid = isNewPasswordValid && isPasswordsMatching;
        
        if (newPassword.length > 0 && newPassword.length < 8) {
            setButtonText("Password Not Strong Enough");
        } else if (newPassword.length >= 8 && !isPasswordsMatching) {
            setButtonText("Passwords Do Not Match");
        } else {
            setButtonText("Update Password");
        }
        
        setIsFormValid(isValid);
        return isValid;
    };

    const handleFormSubmit = (ev) => {
        ev.preventDefault();
        const formData = new FormData(ev.target);
        const formDataObject = {};

        for (let [key, value] of formData.entries()) {
            formDataObject[key] = value;
        }

        if (!validateForm(ev.target)) {
            return;
        }

        dispatch(updatePassword(formDataObject));
    };


    return (
        <div className="accordion info-container p-0 mt-5 lh-lg" id="accordionPassUpdate">
            <div className="accordion-item border-0 billing-info-update-acc">
                <h2 className="accordion-header" id="headingPassUpdate">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapsePassUpdate" aria-expanded="false"
                            aria-controls="collapsePassUpdate">
                        Update Password
                    </button>
                </h2>
                <div id="collapsePassUpdate" className="accordion-collapse collapse" aria-labelledby="headingPassUpdate"
                     data-bs-parent="#accordionPassUpdate">
                    {showSuccess && <div className="alert alert-success text-center m-3" role="alert">
                        Password Updated Successfully.
                    </div>}
                    {showFailed && <div className="alert alert-danger text-center m-3" role="alert">
                        Password Update Failed!
                    </div>}
                    <div className="accordion-body passUpdateBody mx-4 p-4">
                        <form ref={formRef} onSubmit={handleFormSubmit}>
                            <div className="my-2 mt-3">
                                <label className="form-label">Current Password:</label>
                                <input className="form-control" 
                                       type="password" 
                                       placeholder="Enter your current password" 
                                       name="currentPassword"
                                       required={true} />
                            </div>

                            <div className="my-2 mt-3">
                                <label className="form-label">New Password (minimum 8 characters):</label>
                                <input className="form-control" 
                                       type="password" 
                                       placeholder="Enter your new password (minimum 8 characters)" 
                                       name="newPassword"
                                       required={true}
                                       onChange={(e) => validateForm(e.target.form)} />
                            </div>

                            <div className="my-2 mt-3">
                                <label className="form-label">Confirm New Password:</label>
                                <input className="form-control" 
                                       type="password" 
                                       placeholder="Confirm your new password" 
                                       name="confirmPassword"
                                       required={true}
                                       onChange={(e) => validateForm(e.target.form)} />
                            </div>

                            <div className="my-2 mt-4 text-end">
                                <button type="submit" className="btn passUpdateBtn px-3" disabled={!isFormValid}>
                                    {buttonText}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PasswordUpdateSection;
